import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props => props.theme.colors.text.default};
`
